export interface IDashCoordinatorSummary {
    
}